import React, { useEffect, useState } from "react";
import { LoginSVG } from "../images-svg/LoginSvg";
import { useForm, SubmitHandler } from "react-hook-form";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import {
  ChangeGroupAPI,
  GetAccessToken,
  GetAllProvidersIDP,
  LogoutAPI,
  UserGateways,
  UserLogin,
} from "../../api/auth/Authentication";
import { UserDataType } from "../..";
import { toast } from "react-toastify";
import axios from "axios";

type Inputs = {
  email: string;
  password: string;
};
interface ProviderType {
  numberMatched: number;
  numberReturned: number;
  identityProvider: IdentityProvider[];
}
interface IdentityProvider {
  id: string;
  providerName: string;
  alias: string;
  icon: string;
  enabled: boolean;
}

function Login() {
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm<Inputs>();

  const [isOpenEye, setIsOpenEye] = useState(false);
  const [isVerifyEmail, setIsVerifyEmail] = useState(false);
  const [email, setEmail] = useState("");
  const [isDisable, setIsDisable] = useState(false);
  const [facebookProviders, setFacebookProviders] =
    useState<IdentityProvider>();
  const [googleProviders, setGoogleProviders] = useState<IdentityProvider>();
  const [keycloakProviders, setKeycloakProviders] =
    useState<IdentityProvider>();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const refresh_token = searchParams.get("refresh_token");
  const error_message = searchParams.get("error_message");

  const handleClickOpenEye = () => {
    setIsOpenEye(!isOpenEye);
  };

  const getProviders = async () => {
    try {
      const data: ProviderType = (await GetAllProvidersIDP()) as ProviderType;
      if (data) {
        let facebook = data.identityProvider.filter(
          (e: IdentityProvider) => e.alias === "facebook"
        );
        let google = data.identityProvider.filter(
          (e: IdentityProvider) => e.alias === "google"
        );
        let keycloak = data.identityProvider.filter(
          (e: IdentityProvider) => e.alias === "keycloak"
        );
        setFacebookProviders(facebook[0]);
        setGoogleProviders(google[0]);
        setKeycloakProviders(keycloak[0]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const loginProvider = async (alias: string | undefined) => {
    window.location.href = `${process.env.REACT_APP_API_VALLARIS}/core/api/managements/1.0/login/${alias}/token?callback_uri=${process.env.REACT_APP_HOST}/login`;
  };

  const handleError = async (errMsg: string) => {
    toast.error(errMsg, {
      position: "bottom-left",
      autoClose: 3000,
    });
    await LogoutAPI();
    localStorage.removeItem("token_type");
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("extension");
    localStorage.removeItem("user");
  };

  const handleUserGateway = async () => {
    try {
      let key = "org.gistda.hotspot.admin";
      const data = await UserGateways(key);
      if (data) {
        setIsDisable(false);
        navigate(`/dashboard`);
      }
    } catch (error: any) {
      console.log(error);
      setIsDisable(false);
      if (error?.response?.status === 403) {
        handleError("คุณไม่มีสิทธิ์ใช้งาน");
      }
      localStorage.removeItem("user");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("access_token");
      localStorage.removeItem("token_type");
      localStorage.removeItem("expired_at");
      setTimeout(() => {
        navigate("/login", { replace: true });
      }, 500);
    }
  };

  const handleChangeGroup = async (userID: string) => {
    try {
      // let payload = { userId: userID };
      // const { data } = (await ChangeGroupAPI(payload)) as any;
      const { data } = await axios.post(
        "https://faipa.gistda.or.th/api/1.0/hotspots/changegroup",
        { userId: userID }
      );
      if (data === "Success") {
        handleUserGateway();
      }
    } catch (error) {
      console.log(error);
      localStorage.removeItem("user");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("access_token");
      localStorage.removeItem("token_type");
      localStorage.removeItem("expired_at");
      handleError("การเข้าสู่ระบบล้มเหลว ลองอีกครั้ง");
      setTimeout(() => {
        navigate("/login", { replace: true });
      }, 500);
    }
  };

  const handleCheckTokenUser = async (userToken: string) => {
    if (userToken && userToken !== null) {
      try {
        let payload = {
          grant_type: "refresh_token",
          refresh_token: userToken,
        };

        const data: UserDataType = (await GetAccessToken(
          payload
        )) as UserDataType;

        if (data) {
          let user = {
            id: data.user.id,
            firstName: data.user.firstName,
            lastName: data.user.lastName,
            email: data.user.email,
            imageId: data?.user.avatar ?? "",
            role: data.user.role,
          };

          let userJson = JSON.stringify(user);
          localStorage.setItem("user", userJson);
          localStorage.setItem("refresh_token", data.refreshToken);
          localStorage.setItem("access_token", data.accessToken);
          localStorage.setItem("token_type", data.tokenType);
          localStorage.setItem("expired_at", data.expiredAt);
          handleChangeGroup(user.id);
        }
      } catch (error: any) {
        console.log(error);
        if (error?.response?.status === 401) {
          localStorage.removeItem("user");
          localStorage.removeItem("access_token");
          localStorage.removeItem("token_type");
          localStorage.removeItem("expired_at");
          localStorage.removeItem("refresh_token");
        } else {
          handleError("การเข้าสู่ระบบล้มเหลว ลองอีกครั้ง");
        }
        navigate("/login", { replace: true });
      }
    }
  };

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    const payload: any = {
      grant_type: "password",
      accountType: "email",
      username: data?.email,
      password: data?.password,
    };
    setEmail(data.email);
    try {
      setIsDisable(true);
      const data: UserDataType = (await UserLogin(payload)) as UserDataType;
      if (data) {
        let user = {
          id: data.user.id,
          firstName: data.user.firstName,
          lastName: data.user.lastName,
          email: data.user.email,
          imageId: data?.user.avatar ?? "",
          role: data.user.role,
        };

        let userJson = JSON.stringify(user);
        localStorage.setItem("user", userJson);
        localStorage.setItem("refresh_token", data.refreshToken);
        localStorage.setItem("access_token", data.accessToken);
        localStorage.setItem("token_type", data.tokenType);
        localStorage.setItem("expired_at", data.expiredAt);
        handleUserGateway();
      }
    } catch (error: any) {
      console.log(error);
      setIsDisable(false);
      if (error?.response?.status === 400) {
        setError("password", {
          type: "manual",
          message:
            "รหัสผ่านไม่ถูกต้อง ลองอีกครั้งหรือกด “ลืมรหัสผ่าน” เพื่อรีเซ็ต",
        });
      }
      if (error?.response?.status === 403) {
        setIsVerifyEmail(true);
      } else {
        setIsVerifyEmail(false);
      }
    }
  };

  useEffect(() => {
    if (refresh_token && refresh_token !== null && error_message === null) {
      handleCheckTokenUser(refresh_token);
    }
  }, [refresh_token]);

  useEffect(() => {
    if (error_message && error_message !== null) {
      handleError("ไม่สามารถเข้าสู่ระบบได้ , อีเมลนี้ถูกใช้งานแล้ว");
      setTimeout(() => {
        navigate("/login", { replace: true });
      }, 500);
    }
  }, [error_message]);

  useEffect(() => {
    getProviders();
  }, []);

  return (
    <div className="bg-background-app grid grid-cols-12 w-full h-screen font-noto-sans-thai">
      <div className="self-center col-span-10 md:col-span-8  lg:col-span-6 col-start-2 md:col-start-3 lg:col-start-4 w-full h-auto xl:h-[calc(100vh_-_70px)] py-9 relative">
        <div className="w-full flex flex-col gap-4 p-6 max-w-[420px] mx-auto h-auto md:h-full bg-background-paper rounded-3xl border-[1px] border-gray-1 shadow-z16 ">
          <p className="text-xl font-medium leading-[30px] text-center text-text-primary">
            Welcome Back !
          </p>
          <div className="flex flex-col gap-2 items-center justify-center">
            <p className="text-base font-medium leading-6 text-center text-text-primary">
              เข้าสู่ระบบ
            </p>
            {isVerifyEmail && (
              <div className="flex gap-2 items-center">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.3 3.5H7.7V4.9H6.3V3.5ZM6.3 6.3H7.7V10.5H6.3V6.3ZM7 0C3.136 0 0 3.136 0 7C0 10.864 3.136 14 7 14C10.864 14 14 10.864 14 7C14 3.136 10.864 0 7 0ZM7 12.6C3.913 12.6 1.4 10.087 1.4 7C1.4 3.913 3.913 1.4 7 1.4C10.087 1.4 12.6 3.913 12.6 7C12.6 10.087 10.087 12.6 7 12.6Z"
                    fill="#F05B50"
                  />
                </svg>

                <p className="whitespace-nowrap text-error-main text-xs font-normal leading-[18px]">
                  คุณยังไม่ได้ยืนยันที่อยู่อีเมล กรุณาคลิก
                </p>

                <Link to={`/login/verify?email=${email}`}>
                  <p className="whitespace-nowrap text-error-main text-xs font-normal leading-[18px] underline cursor-pointer">
                    “ยืนยันอีเมล”
                  </p>
                </Link>
              </div>
            )}
          </div>
          <form
            className="flex flex-col gap-4"
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className="flex flex-col gap-2 w-full ">
              <label className="text-sm text-text-primary" htmlFor="email">
                อีเมล
              </label>
              <input
                id="email"
                placeholder="อีเมล"
                className={`w-full h-10 focus:!outline-none text-sm placeholder:text-text-disabled px-4 py-1 self-stretch rounded-xl border-[1px] ${
                  errors.email ? "border-error-main" : "border-gray-1"
                }`}
                {...register("email", {
                  required: "กรุณากรอกอีเมล",
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: "กรุณากรอกอีเมลให้ถูกต้อง",
                  },
                })}
              />
              {errors.email && (
                <span className="text-xs text-error-main font-light leading-[18px]">
                  {errors.email.message}
                </span>
              )}
            </div>
            <div className="flex flex-col gap-2 w-full ">
              <label className="text-sm text-text-primary" htmlFor="password">
                รหัสผ่าน
              </label>
              <div
                className={`w-full h-10 rounded-xl border-[1px] ${
                  errors.password ? "border-error-main" : "border-gray-1"
                } flex gap-4`}
              >
                <input
                  id="password"
                  placeholder="รหัสผ่าน"
                  type={isOpenEye ? "text" : "password"}
                  className="w-full focus:!outline-none rounded-xl text-sm placeholder:text-text-disabled px-4 py-1 self-stretch"
                  {...register("password", { required: "กรุณากรอกรหัสผ่าน" })}
                />
                <div
                  className="items-center self-center w-8 cursor-pointer"
                  onClick={handleClickOpenEye}
                >
                  {isOpenEye ? (
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8 4.33329C9.84 4.33329 11.3333 5.82662 11.3333 7.66662C11.3333 8.00662 11.2667 8.33329 11.1733 8.63995L13.2133 10.68C14.14 9.85995 14.8733 8.83329 15.3333 7.65995C14.18 4.73995 11.3333 2.66662 8 2.66662C7.15334 2.66662 6.34 2.79995 5.57334 3.04662L7.02 4.49329C7.33334 4.39995 7.66 4.33329 8 4.33329ZM1.80667 2.10662C1.54667 2.36662 1.54667 2.78662 1.80667 3.04662L3.12 4.35995C2.04 5.21995 1.18001 6.35329 0.666672 7.66662C1.82001 10.5933 4.66667 12.6666 8 12.6666C9.01334 12.6666 9.98 12.4666 10.8733 12.12L12.6867 13.9333C12.9467 14.1933 13.3667 14.1933 13.6267 13.9333C13.8867 13.6733 13.8867 13.2533 13.6267 12.9933L2.75334 2.10662C2.49334 1.84662 2.06667 1.84662 1.80667 2.10662ZM8 11C6.16 11 4.66667 9.50662 4.66667 7.66662C4.66667 7.15329 4.78667 6.66662 4.99334 6.23995L6.04001 7.28662C6.02001 7.40662 6 7.53329 6 7.66662C6 8.77329 6.89334 9.66662 8 9.66662C8.13334 9.66662 8.25334 9.64662 8.38 9.61995L9.42667 10.6666C8.99334 10.88 8.51334 11 8 11ZM9.98 7.44662C9.88 6.51329 9.14667 5.78662 8.22 5.68662L9.98 7.44662Z"
                        fill="#8E8E8E"
                      />
                    </svg>
                  ) : (
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.00008 2.66663C4.66675 2.66663 1.82008 4.73996 0.666748 7.66663C1.82008 10.5933 4.66675 12.6666 8.00008 12.6666C11.3334 12.6666 14.1801 10.5933 15.3334 7.66663C14.1801 4.73996 11.3334 2.66663 8.00008 2.66663ZM8.00008 11C6.16008 11 4.66675 9.50663 4.66675 7.66663C4.66675 5.82663 6.16008 4.33329 8.00008 4.33329C9.84008 4.33329 11.3334 5.82663 11.3334 7.66663C11.3334 9.50663 9.84008 11 8.00008 11ZM8.00008 5.66663C6.89341 5.66663 6.00008 6.55996 6.00008 7.66663C6.00008 8.77329 6.89341 9.66663 8.00008 9.66663C9.10675 9.66663 10.0001 8.77329 10.0001 7.66663C10.0001 6.55996 9.10675 5.66663 8.00008 5.66663Z"
                        fill="#B0B0B0"
                      />
                    </svg>
                  )}
                </div>
              </div>
              <div className="flex  items-center gap-3 justify-end self-stretch">
                {errors.password && (
                  <span className="text-xs w-full text-error-main whitespace-nowrap font-light leading-[18px]">
                    {errors.password.message}
                  </span>
                )}
                <Link to={`/forgot-password`}>
                  <p className="text-xs text-text-primary w-full text-right whitespace-pre">
                    ลืมรหัสผ่าน ?
                  </p>
                </Link>
              </div>
            </div>
            <button
              type="submit"
              disabled={isDisable}
              className="w-full bg-primary-main h-10 disabled:bg-gray-2 disabled:text-text-disabled hover:bg-opacity-70 px-10 py-2 text-sm text-primary-contrast leading-[22px] rounded-xl"
            >
              เข้าสู่ระบบ
            </button>
          </form>
          <p className="text-sm leading-[22px] text-center text-text-secondary">
            หรือ เข้าสู่ระบบด้วย
          </p>
          <div className="flex flex-col gap-4">
            <button
              disabled={!googleProviders?.enabled}
              onClick={() => loginProvider(googleProviders?.alias)}
              type="button"
              className="w-full h-10 flex gap-[10px]  bg-primary-contrast border-[1px] border-gray-2 items-center px-[33%] md:px-[40%] py-1 text-sm text-text-primary leading-[22px] rounded-xl"
            >
              <p className="min-w-4">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.0001 8.17778C16.0001 7.52001 15.9456 7.04001 15.8277 6.54224H8.16333V9.51109H12.6622C12.5715 10.2489 12.0817 11.36 10.9932 12.1066L10.978 12.206L13.4013 14.0458L13.5692 14.0622C15.1111 12.6667 16.0001 10.6133 16.0001 8.17778Z"
                    fill="#4285F4"
                  />
                  <path
                    d="M8.16314 16C10.3672 16 12.2175 15.2889 13.569 14.0623L10.993 12.1067C10.3037 12.5778 9.37853 12.9067 8.16314 12.9067C6.00442 12.9067 4.17224 11.5112 3.51912 9.58228L3.42338 9.59024L0.903559 11.5014L0.870605 11.5911C2.21299 14.2044 4.97037 16 8.16314 16Z"
                    fill="#34A853"
                  />
                  <path
                    d="M3.51924 9.58216C3.3469 9.08439 3.24717 8.55101 3.24717 7.99993C3.24717 7.44879 3.3469 6.91547 3.51017 6.4177L3.50561 6.31169L0.954204 4.36987L0.870727 4.40879C0.317464 5.49324 0 6.71105 0 7.99993C0 9.28882 0.317464 10.5066 0.870727 11.591L3.51924 9.58216Z"
                    fill="#FBBC05"
                  />
                  <path
                    d="M8.16338 3.09331C9.69623 3.09331 10.7302 3.7422 11.3198 4.28446L13.6237 2.08C12.2087 0.791115 10.3674 0 8.16338 0C4.97061 0 2.21324 1.79554 0.87085 4.40886L3.51029 6.41777C4.17248 4.48889 6.00467 3.09331 8.16338 3.09331Z"
                    fill="#EB4335"
                  />
                </svg>
              </p>
              <p className="w-auto">Google</p>
            </button>
            {/* <button
              disabled={!facebookProviders?.enabled}
              onClick={() => loginProvider(facebookProviders?.alias)}
              type="button"
              className="w-full h-10 flex gap-[10px] bg-primary-contrast border-[1px] border-gray-2 items-center px-[33%] md:px-[40%] py-1 text-sm text-text-primary leading-[22px] rounded-xl"
            >
              <p className="min-w-4">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16 8C16 3.58175 12.4183 0 8 0C3.58175 0 0 3.58169 0 8C0 11.993 2.9255 15.3027 6.75 15.9028V10.3125H4.71875V8H6.75V6.2375C6.75 4.2325 7.94438 3.125 9.77169 3.125C10.647 3.125 11.5625 3.28125 11.5625 3.28125V5.25H10.5538C9.55988 5.25 9.25 5.86669 9.25 6.49937V8H11.4688L11.1141 10.3125H9.25V15.9028C13.0745 15.3027 16 11.9931 16 8Z"
                    fill="#1877F2"
                  />
                  <path
                    d="M11.1141 10.3125L11.4688 8H9.25V6.49937C9.25 5.86662 9.55994 5.25 10.5538 5.25H11.5625V3.28125C11.5625 3.28125 10.647 3.125 9.77169 3.125C7.94438 3.125 6.75 4.2325 6.75 6.2375V8H4.71875V10.3125H6.75V15.9028C7.16351 15.9676 7.58144 16.0001 8 16C8.41856 16.0001 8.83649 15.9676 9.25 15.9028V10.3125H11.1141Z"
                    fill="white"
                  />
                </svg>
              </p>
              <p className="w-auto">Facebook</p>
            </button> */}
            <button
              disabled={!keycloakProviders?.enabled}
              onClick={() => loginProvider(keycloakProviders?.alias)}
              type="button"
              className="h-10 flex gap-[10px] bg-primary-contrast border-[1px] border-gray-2 items-center px-[33%] md:px-[40%] py-1 text-sm text-text-primary leading-[22px] rounded-xl"
            >
              <p className="min-w-4">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_2541_3039)">
                    <path
                      d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
                      fill="#008AAA"
                    />
                    <path
                      d="M12.2844 6.17971H11.025C11.0016 6.17971 10.9782 6.16721 10.9672 6.1469L9.9563 4.39377C9.9438 4.37346 9.92192 4.36096 9.89692 4.36096H5.77192C5.74849 4.36096 5.72505 4.37346 5.71411 4.39377L4.66255 6.21252L3.65005 7.96565C3.63911 7.98596 3.63911 8.01096 3.65005 8.03284L4.66255 9.78596L5.71255 11.6063C5.72349 11.6266 5.74692 11.6406 5.77036 11.6391H9.89692C9.92036 11.6391 9.9438 11.6266 9.9563 11.6063L10.9688 9.85315C10.9797 9.83284 11.0032 9.81877 11.0266 9.82034H12.286C12.3282 9.82034 12.361 9.78596 12.361 9.74534V6.25627C12.3594 6.21409 12.325 6.17971 12.2844 6.17971ZM7.46099 9.85315L7.1438 10.4C7.13911 10.4078 7.1313 10.4156 7.12349 10.4203C7.11411 10.425 7.10474 10.4281 7.0938 10.4281H6.46411C6.44224 10.4281 6.42192 10.4172 6.41255 10.3969L5.47349 8.76721L5.3813 8.60627L5.0438 8.02971C5.03911 8.0219 5.03599 8.01252 5.03755 8.00159C5.03755 7.99221 5.04067 7.98127 5.04536 7.97346L5.38442 7.38596L6.41411 5.60471C6.42505 5.58596 6.44536 5.57346 6.46567 5.57346H7.0938C7.10474 5.57346 7.11567 5.57659 7.12661 5.58127C7.13442 5.58596 7.14224 5.59221 7.14692 5.60159L7.46411 6.15159C7.47349 6.17034 7.47192 6.19377 7.46099 6.21096L6.4438 7.97346C6.43911 7.98127 6.43755 7.99065 6.43755 7.99846C6.43755 8.00784 6.44067 8.01565 6.4438 8.02346L7.46099 9.7844C7.47505 9.80784 7.47349 9.83284 7.46099 9.85315ZM10.6188 8.02971L10.2813 8.60627L10.1891 8.76721L9.25005 10.3969C9.23911 10.4156 9.22036 10.4281 9.19849 10.4281H8.5688C8.55786 10.4281 8.54849 10.425 8.53911 10.4203C8.5313 10.4156 8.52349 10.4094 8.5188 10.4L8.20161 9.85315C8.18755 9.83284 8.18755 9.80784 8.20005 9.78752L9.21724 8.02659C9.22192 8.01877 9.22349 8.0094 9.22349 8.00159C9.22349 7.99221 9.22036 7.9844 9.21724 7.97659L8.20005 6.21409C8.18911 6.19534 8.18755 6.17346 8.19692 6.15471L8.51411 5.60471C8.5188 5.5969 8.52661 5.58909 8.53442 5.5844C8.5438 5.57815 8.55474 5.57659 8.56724 5.57659H9.19849C9.22036 5.57659 9.24067 5.58752 9.25005 5.60784L10.2797 7.38909L10.6188 7.97659C10.6235 7.98596 10.6266 7.99534 10.6266 8.00471C10.6266 8.01096 10.6235 8.02034 10.6188 8.02971Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_2541_3039">
                      <rect width="16" height="16" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </p>
              <p>Keycloak</p>
            </button>
          </div>
          <div className="pt-6 flex flex-col items-center">
            <p className="text-text-primary text-sm leading-[22px]">
              ถ้าคุณเป็นผู้ใช้งานใหม่ กรุณาลงทะเบียน
            </p>
            <p className="text-text-primary text-sm leading-[22px]">
              ก่อนเข้าใช้งานระบบโดย{" "}
              <Link to={`/register`}>
                <span className="font-medium text-primary-main">
                  ลงทะเบียนที่นี่ !
                </span>
              </Link>
            </p>
          </div>
        </div>
        <div className="absolute bottom-[96px] hidden md:block md:-left-12 md2:-left-8 lg:-left-12 lg2:-left-9 lg3:-left-3 xl:left-14 xl1:left-9 2xl:left-[114px]">
          <LoginSVG />
        </div>
      </div>
    </div>
  );
}

export default Login;
